export const availableTransitions = {
  ABORTABLE_STATUSES: ['WAITING_TO_SEND_CONTRACT', 'WAITING_TO_SIGN_CONTRACT'],
  CAN_CREATE_COLLABORATOR_IN_IDENTITY_ACCESS_STATUSES: [
    'WAITING_TO_SEND_CONTRACT',
    'WAITING_TO_SIGN_CONTRACT',
    'SIGNED',
    'COMPLETED_SUCCESS',
  ],
  CANCELLABLE_STATUSES: [
    'WAITING_FOR_COLLABORATOR_DATA',
    'WAITING_FOR_DIRECTOR_VALIDATION',
    'WAITING_FOR_DIRECTOR_AND_LEGAL_VALIDATION',
    'WAITING_FOR_HR_DATA',
    'WAITING_FOR_LEGAL_VALIDATION',
    'QUEUED_SEND_EMAIL_PENDING',
    'SCHEDULED_FOR_CONVERSION_DATE',
    'SCHEDULED_FOR_EXTENSION_DATE',
  ],
  DIRECTOR_VALIDATION_STATUSES: [
    'WAITING_FOR_DIRECTOR_VALIDATION',
    'WAITING_FOR_DIRECTOR_AND_LEGAL_VALIDATION',
  ],
  FORCE_COMPLETE_STATUSES: [
    'WAITING_FOR_IDENTITY_ACCESS_RESPONSE',
    'STATUS_WAITING_FOR_IDENTITY_ACCESS_RESPONSE',
    'WAITING_TO_BE_EXECUTED',
    'WAITING_FOR_OSMOS_RESPONSE',
    'STATUS_WAITING_FOR_OSMOS_RESPONSE',
    'SCHEDULED_FOR_CONVERSION_DATE',
    'SCHEDULED_FOR_EXTENSION_DATE',
    'SCHEDULED_FOR_START_DATE',
    'PENDING_MUTATION_COLLABORATOR_PROCESS',
  ],
  LEGAL_VALIDATION_STATUSES: [
    'WAITING_FOR_LEGAL_VALIDATION',
    'WAITING_FOR_DIRECTOR_AND_LEGAL_VALIDATION',
  ],
  RECTIFY_CONTRACT_DATA_STATUSES: [
    'QUEUED_SEND_EMAIL_PENDING',
    'WAITING_FOR_COLLABORATOR_DATA',
  ],
  MODIFY_CONTRACT_DATA_STATUSES: [
    'WAITING_FOR_HR_DATA',
    'WAITING_TO_SEND_CONTRACT',
    'WAITING_TO_SIGN_CONTRACT',
  ],
  SEND_EMAIL_COLLABORATOR_START_STATUSES: [
    'WAITING_FOR_COLLABORATOR_DATA',
    'QUEUED_SEND_EMAIL_PENDING',
  ],
  LEAVE_TRANSITIONS: {
    CANCELLABLE_STATUSES: ['WAITING_TO_BE_EXECUTED', 'WAITING_TO_START'],
  },
  SIGN_ON_PAPER: [
    'WAITING_FOR_DIRECTOR_VALIDATION',
    'WAITING_FOR_DIRECTOR_AND_LEGAL_VALIDATION',
    'WAITING_FOR_HR_DATA',
    'WAITING_FOR_LEGAL_VALIDATION',
    'WAITING_TO_SIGN_CONTRACT',
    'WAITING_TO_SEND_CONTRACT',
    'QUEUED_SEND_EMAIL_PENDING',
  ],
  LINK_ADD_ADDRESS_DATA: ['STATUS_WAITING_FOR_ADDRESS_DATA'],
  LINK_ADD_FISCAL_DATA: ['STATUS_WAITING_FOR_FISCAL_DATA'],
  LINK_ADD_BANK_DATA: ['STATUS_WAITING_FOR_BANK_DATA'],
  LINK_ADD_LABOR_DATA: ['STATUS_WAITING_FOR_LABOR_DATA'],
  UNFINISHED_PROCESS_STATUSES: [
    'STATUS_WAITING_FOR_ADDRESS_DATA',
    'STATUS_WAITING_FOR_FISCAL_DATA',
    'STATUS_WAITING_FOR_BANK_DATA',
    'STATUS_WAITING_FOR_LABOR_DATA',
  ],
  COMPLETED_STATUSES: ['COMPLETED_SUCCESS'],
}
export const processStatuses = [
  'COMPLETED_SUCCESS',
  'STATUS_WAITING_FOR_ADDRESS_DATA',
  'STATUS_WAITING_FOR_FISCAL_DATA',
  'STATUS_WAITING_FOR_BANK_DATA',
  'STATUS_WAITING_FOR_LABOR_DATA',
  'STATUS_WAITING_FOR_OSMOS_RESPONSE',
  'ABORTED',
]
export const mutationProcessStatuses = [
  'PENDING_MUTATION_COLLABORATOR_PROCESS',
  'CANCEL_MUTATION_COLLABORATOR_PROCESS',
  'FINISH_MUTATION_COLLABORATOR_PROCESS',
]

export const conversionProcessStatuses = [
  'SCHEDULED_FOR_CONVERSION_DATE',
  'COMPLETED_SUCCESS',
  'CANCELLED',
]
export const extensionProcessStatuses = [
  'SCHEDULED_FOR_EXTENSION_DATE',
  'COMPLETED_SUCCESS',
  'CANCELLED',
]

export const timebaseChangeProcessStatuses = [
  'CANCELLED',
  'SIGNED',
  'SIGNED_ON_PAPER',
  'NOT_SIGNED',
  'PENDING_SENDING',
  'PENDING_SIGNATURE',
]
export const complementaryPactProcessStatuses = [
  'CANCELLED',
  'SIGNED',
  'SIGNED_ON_PAPER',
  'NOT_SIGNED',
  'PENDING_SENDING',
  'PENDING_SIGNATURE',
]
export const shiftReductionInitialStatus = [
  'SIGNED_ON_PAPER',
  'PENDING_SIGNATURE',
]

export const positionsWithOutTeam = [
  'DIRECTOR DE TIENDA',
  'DIRECTOR TALLER REGIONAL',
  'DIRECTOR ALMACÉN',
  'ORGANIZADOR SEGURIDAD EXP',
]

export const leaveOfAbsenceLeaveReasons = [
  'VOLUNTARY_LEAVE',
  'FAMILY_CARE_LEAVE',
  'MATERNITY_LEAVE',
  5,
  6,
  7,
]

export const leaveReasons = [
  'CONSUMED_TEMPORARY_INCAPACITY',
  'VOLUNTARY_RESIGNATION',
  'DISMISSAL',
  'MATERNITY_LEAVE',
  'FAMILY_CARE_LEAVE',
  'VOLUNTARY_LEAVE',
  'CONTRACT_END',
  'HAS_NOT_STARTED_TO_WORK',
  'NOT_PASSED_TRIAL',
  'PENSIONIST',
]

export const leaveProcessTypes = {
  LEAVE_OF_ABSENCE_PROCESS_MEX: 'LEAVE_OF_ABSENCE_PROCESS_MEX',
  LEAVE_PROCESS_MEX: 'LEAVE_PROCESS_MEX',
}

export const leaveOfAbsenceProcessTypes = ['LEAVE_OF_ABSENCE_PROCESS_MEX']

export const contractTypeFullPartial = {
  FULL_TIME: 'TC',
  PARTIAL_TIME: 'TP',
}

export const contractWeeklyBasetimes = {
  TC: {
    min: 20,
    max: 40,
  },
  TP: {
    min: 4,
    max: 34,
  },
}

export const contractProcessTypes = {
  HIRING_CONTRACT_PROCESS_MEX: 'HIRING_CONTRACT_PROCESS_MEX',
  CONVERSION_CONTRACT_PROCESS_MEX: 'CONVERSION_CONTRACT_PROCESS_MEX',
  EXTENSION_CONTRACT_PROCESS_MEX: 'EXTENSION_CONTRACT_PROCESS_MEX',
  REHIRING_CONTRACT_PROCESS_MEX: 'REHIRING_CONTRACT_PROCESS_MEX',
}

export const aggregates = {
  HIRING_CONTRACT_PROCESS_MEX: 'hiring',
  CONVERSION_CONTRACT_PROCESS_MEX: 'conversion',
  EXTENSION_CONTRACT_PROCESS_MEX: 'extension',
}

// These are the codes for position POSITION_MX_STORE_SPORT_LEADER
export const collaboratorStoreSportVendorCodes = ['HOT.CAI.ACC']

export const pastPlanningMonths = 2

export function urlQueryStringBuilder(payload = {}) {
  const queryOptions = []
  if ({}.hasOwnProperty.call(payload, 'sort')) {
    queryOptions.push(`sort=${payload.sort}`)
  }

  if ({}.hasOwnProperty.call(payload, 'filters')) {
    Object.keys(payload.filters).forEach((key) => {
      if (payload.filters[key] && payload.filters[key].length) {
        return queryOptions.push(`filter[${key}]=${payload.filters[key]}`)
      }
    })
  }

  let queryString = queryOptions.length > 0 ? '?' + queryOptions.join('&') : ''
  queryString = encodeURI(queryString)

  return queryString
}
